import React from 'react';
export const Button = ({ action, highlighted = false, label, type, }) => {
    let classList = 'w-full md:w-44 py-2 border border-navy-blue-500 rounded font-semibold text-base ';
    if (type === 'primary') {
        classList += `${highlighted
            ? 'bg-vital-brand-blue hover:bg-vital-brand-blue-light'
            : 'bg-navy-blue-500 hover:bg-medium-blue'} text-white`;
    }
    else {
        classList += `${highlighted
            ? 'bg-navy-blue-500 hover:bg-medium-blue text-white'
            : 'bg-white hover:border-medium-blue text-navy-blue-500 hover:text-medium-blue'}`;
    }
    return (React.createElement("button", { type: "button", className: classList, onClick: action }, label));
};
